import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'

export const useNotificationPageStyle = makeStyles((theme: Theme) =>
  createStyles({
    clearButton: {
      padding: theme.spacing(0.5),
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    searchControl: {
      [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(2.35),
      },
      '& .MuiOutlinedInput-root': {
        minHeight: 42,
        boxSizing: 'border-box',
      },
    },
    readStatusSelect: {
      [theme.breakpoints.up('lg')]: {
        marginTop: -20,
      },
    },
    notificationsCard: {
      borderRadius: theme.shape.borderRadius * 2,
      overflow: 'hidden',
      boxShadow: 'none',
      '&.MuiPaper-elevation0': {
        boxShadow: 'none',
      },
    },
    cardContent: {
      padding: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    emptyStateContainer: {
      padding: theme.spacing(6, 0),
    },
    linearProgressVisible: {
      visibility: 'visible',
    },
    linearProgressHidden: {
      visibility: 'hidden',
    },
  })
)
